/**
 * Roteador. Endereços de verdade (`/inc/<id>`), não `#/`: o cenário aberto precisa de um
 * endereço que o usuário consiga copiar e mandar para o colega, e `#` some de várias
 * ferramentas. Exige o desvio para `index.html` na publicação — está no `_redirects`.
 *
 * A tradução rota ⇄ endereço mora em `caminhos.ts` (pura, testada); aqui fica o que
 * precisa do navegador: histórico, `popstate` e o aviso a quem desenha.
 */
import { caminhoDe, rotaDe } from './caminhos';
import type { Rota } from './caminhos';

export { caminhoDe, rotaDe };
export type { Rota };

export function rotaAtual(): Rota {
  return rotaDe(window.location.pathname);
}

type Ouvinte = (r: Rota) => void;
const ouvintes = new Set<Ouvinte>();

/** Recebe cada troca de rota, inclusive as do botão "voltar" do navegador. */
export function aoNavegar(o: Ouvinte): () => void {
  ouvintes.add(o);
  return () => ouvintes.delete(o);
}

function anunciar(): void {
  const r = rotaAtual();
  for (const o of ouvintes) o(r);
}

/**
 * Navega. `substituir` troca a entrada do histórico em vez de empilhar — usado quando o
 * destino é uma correção de rota (entrou sem sessão, ou só existe uma incorporadora), e
 * empilhar deixaria o botão "voltar" preso num pingue-pongue.
 */
export function ir(r: Rota, opcoes: { substituir?: boolean } = {}): void {
  const destino = caminhoDe(r);
  if (destino === window.location.pathname) {
    anunciar();
    return;
  }
  if (opcoes.substituir === true) window.history.replaceState(null, '', destino);
  else window.history.pushState(null, '', destino);
  anunciar();
}

/** Redesenha a rota atual — o que as telas chamam depois de criar ou renomear algo. */
export function recarregar(): void {
  anunciar();
}

export function iniciarRoteador(): void {
  window.addEventListener('popstate', anunciar);
}
